import React from 'react'
import { Button } from '@mui/material';
import { useGlobalStore } from '../../../common';

function ImportButton(props) {
    const { children, color, disabled, onClick, variant } = props;

    let selectedItems = useGlobalStore(state=> state.pagesV2['hospitalservices-master-landing'].selected);

    return (
        <>
            <Button
                    disabled={(selectedItems?.length === 0 || disabled) ?? false}
                    variant={variant ? variant : 'contained'}
                    onClick={onClick ?? onClick}
                    color={color ? color : "primary"}>
                    {children}
            </Button>
        </>
    )
}

export default ImportButton